import React from "react";

const Dashboard = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_2"
    width="27.813"
    height="27.813"
    viewBox="0 0 27.813 27.813"
    className={className}
  >
    <g id="grid">
      <path
        id="Path_1220"
        d="M12.271 3H6.09A3.09 3.09 0 0 0 3 6.09v6.181a3.09 3.09 0 0 0 3.09 3.09h6.181a3.09 3.09 0 0 0 3.09-3.09V6.09A3.09 3.09 0 0 0 12.271 3z"
        className="cls-1"
        transform="translate(-3 -3)"
      />
      <path
        id="Path_1221"
        d="M22.271 3H16.09A3.09 3.09 0 0 0 13 6.09v6.181a3.09 3.09 0 0 0 3.09 3.09h6.181a3.09 3.09 0 0 0 3.09-3.09V6.09A3.09 3.09 0 0 0 22.271 3z"
        className="cls-1"
        transform="translate(2.452 -3)"
      />
      <path
        id="Path_1222"
        d="M12.271 13H6.09A3.09 3.09 0 0 0 3 16.09v6.181a3.09 3.09 0 0 0 3.09 3.09h6.181a3.09 3.09 0 0 0 3.09-3.09V16.09a3.09 3.09 0 0 0-3.09-3.09z"
        className="cls-1"
        transform="translate(-3 2.452)"
      />
      <path
        id="Path_1223"
        d="M22.271 13H16.09A3.09 3.09 0 0 0 13 16.09v6.181a3.09 3.09 0 0 0 3.09 3.09h6.181a3.09 3.09 0 0 0 3.09-3.09V16.09a3.09 3.09 0 0 0-3.09-3.09z"
        className="cls-1"
        transform="translate(2.452 2.452)"
      />
    </g>
  </svg>
);

export default Dashboard;
